module.exports = __webpack_public_path__ + "static/media/close.f5daab08.svg";